module.exports = __webpack_public_path__ + "static/photo-872c4902805580a9cf4ed3fa6055a06b.jpg";